import React from 'react';
import { Button, Divider, Header, Segment } from 'semantic-ui-react';
import ModalBase from 'src/modulos/Cobranzas/componentes/FichaDeApoderado/Componentes/ModalBase';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import FormularioGastos from './componentes/FormularioGastos';
import TablaGastos from './componentes/TablaGastos';
import {
    ComandoIngresarGastoDiario,
    GastoDiario,
    GastoDiarioDesdeServer,
    ListaDeResponsables,
} from './tipos';

interface State {
    readonly cargando: boolean;
    readonly datos: ReadonlyArray<GastoDiarioDesdeServer>;
    readonly listaDeResponsables: ReadonlyArray<ListaDeResponsables>;
    error: boolean;
}

class Gastos extends React.Component<{}, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        cargando: true,
        datos: [],
        listaDeResponsables: [],
        error: false,
    };

    public componentDidMount() {
        this.obtenerGastosDiarios();
        this.obtenerListaDeResponsables();
    }

    public render() {
        const { cargando, datos, listaDeResponsables, error } = this.state;

        if (cargando) {
            return <h1>Cargando...</h1>;
        }

        return (
            <div>
                {error && (
                    <ModalBase
                        cabecera='Ocurrió un error'
                        iconoCabecera='exclamation triangle'
                        contenido='Ocurrió un error al ingresar el gasto. Por favor inténtelo
                        nuevamente'
                        acciones={
                            <Button
                                content='Entendido'
                                onClick={() => this.setState({ error: false })}
                            />
                        }
                    />
                )}

                <Header as='h1'>Gastos diarios</Header>
                <Divider hidden />

                <Segment>
                    <FormularioGastos
                        alRegistrarGasto={this.ingresarGastoDiario}
                        listaDeResponsables={listaDeResponsables}
                    />
                </Segment>

                <Divider hidden />

                <Header as='h2'>Registro de gastos diarios</Header>
                <TablaGastos
                    gastos={datos}
                    alModificarGastos={this.obtenerGastosDiarios}
                    listaDeResponsables={listaDeResponsables}
                />
            </div>
        );
    }

    private readonly obtenerGastosDiarios = () => {
        clienteApi
            .ejecutar('obtenerGastosDiarios')
            .then(datos => {
                this.setState({ cargando: false, datos: datos.gastosDiarios });
            })
            .catch(this.context.mostrarModalError);
    };

    private readonly obtenerListaDeResponsables = () => {
        clienteApi
            .ejecutar('obtenerListaDeResponsablesDeGastosDiarios')
            .then(listaDeResponsables => {
                this.setState({ listaDeResponsables });
            })
            .catch(this.context.mostrarModalError);
    };

    private readonly ingresarGastoDiario = async (datos: GastoDiario) => {
        const {
            montoGasto,
            responsableGasto,
            motivoGasto,
            otroMotivoGasto,
            observacionesGasto,
        } = datos;

        const comando: ComandoIngresarGastoDiario = {
            montoGasto,
            responsableGasto,
            motivoGasto,
            otroMotivoGasto,
            observacionesGasto,
        };

        try {
            await clienteApi.ejecutar('ingresarGastoDiario', comando);
            this.obtenerGastosDiarios();
        } catch (error) {
            this.context.mostrarModalError(error);
            this.setState({ error: true });
        }
    };
}

export default Gastos;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Gastos/index.tsx